<template>
  <div>
    <!--<breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互_new'},{title:'日清计划'}]" />-->
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
				<div class="h-thirdColumn w-newColumn">
					<el-form-item label="拜访时间">
						<el-date-picker
						 :clearable="false"
						  type="date"
						  placeholder="选择时间"
						  v-model="q.visitDate"
						  style="width: 100%;"
						  value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="提报人">
						<el-input v-model="q.planUserName" placeholder="请输入提报人姓名" :clearable="true"></el-input>
					</el-form-item>
<!--					<el-form-item label="区域">
						<brselect category="YLRegion" :v="q.areaCode" v-model="q.areaCode" :clearable="true"></brselect>
					</el-form-item>-->
			  </div>

            <div class="h-formBtnOut h-columnCenter">
              <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
              <!--<el-button v-if="isfb==1" class="h-btn h-formBtn h-bggreen" @click="publishRank">发布排行</el-button>
              <el-button class="h-btn h-formBtn h-bggreen" @click="checkRank">查看总排名</el-button>-->
            </div>
          </el-form>
        </div>
      </div>
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :data="tableData"
          :border="true"
          stripe
		  max-height="560"
          style="width: 100%"
          >
          <el-table-column type="selection" width="45" label="全选"></el-table-column>
          <el-table-column fixed type="index" label="#" width="40"></el-table-column>
          <el-table-column prop="customerName" label="客户名称" width="180" :show-overflow-tooltip="true"></el-table-column>
		      <el-table-column prop="visitDate" label="拜访时间"  width="120" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="visitContent" label="拜访内容" width="240" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <pre align="left">{{scope.row.visitContent}}</pre>
            </template>
          </el-table-column>
            <el-table-column prop="planUserName" label="提报人" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="planCreateTime" label="计划创建时间" width="180" :show-overflow-tooltip="true"></el-table-column>
          <!--<el-table-column prop="comment" label="亮点及评价" width="200" :show-overflow-tooltip="true"></el-table-column>-->
          <el-table-column prop="sysScore" label="系统评分" min-width="80" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            width="120"
          >
            <template slot-scope="scope">
				<div style="text-align: left;">
					<el-button
					   type="text"
					   size="small"
					   class="h-tableLink h-btn"
					   @click="checkDetail(scope.row.id)"
					 >查看</el-button>
				</div>

            </template>
          </el-table-column>
        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" />
          </div>
        </div>
      </div>
    </div>
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>

  </div>
</template>

<script>
import ss from "../../api/SystemService";
import updownfile from '../../utils/updownfile'

export default {
  data() {
    return {
      //表单
      q: {
        visitDate:this.getNowTime(),
        planUserName:null,
        pageSize: 10,
        pageNo: 1,
        total:0,
      },
      isfb:1,
      showhistory:false,
      instid:null,
      pingfen:'暂无',
      paiming:'暂无',
      //表格
      multipleSelection: [],
      multipleSelectionDialog:[],
      tableData: [],
      //发布排行
      dialogFlag:false,
      sumRank:[],
      nosum:'',
      nosoc:'',
      q2: {
          pageSize: 10,
          pageNo: 1,
          total:0,
          rqstatus:'',
      },
    };
  },
  created() {
  },
    beforeRouteLeave(to, from, next) {
        from.meta.keepAlive = false;
        next();
    },
    methods: {
    genzongLiuch(r){
      this.instid = r.instid;
      this.showhistory = true;
    },
    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //弹框表格
    handleSelectionChangeDialog(val){
      this.multipleSelectionDialog = val;
    },
    query(){
      ss.DailyPlan.checkPage(this.q).then(rd => {
        this.q.total = rd.total;
        this.tableData = rd.records;
      });
    },
    shenhe(id){
      //修改
      this.$router.push({path: '/presentation', query: {rqId:id }});
    },
    handleFilter() {
      this.query();
    },
    checkRank() {
      this.$router.push("/paiming");
    },
    typeIndex(index){
      return index+(this.q2.pageNo-1)*this.q2.pageSize+1;
    },
    checkDetail(id){
      //查看详情
      this.$router.push({path: '/dailyPlanDetail', query: {rqId:id }});
    },
    //明细导出
			exportExcel() {
				var idlist=[];
				this.multipleSelection.forEach(element => {
					idlist.push(element.id);
				});
				this.q.ids = idlist
                updownfile.down("/api/swyl/v1/dailyClear/userDailyClear/downloadExcel",this.q,"post",'data');
      },
    //重置
    rest() {
      var visitDate=this.getNowTime();
      var planUserName=this.planUserName;
      var pageSize=this.q.pageSize;
      var pageNo=this.q.pageNo;
      var total=this.q.total;
      this.q= {
          visitDate: visitDate,
          planUserName: planUserName,
          pageSize: pageSize,
          pageNo: pageNo,
          total:total,
      }
    },

      //处理默认选中当前日期
      getNowTime() {
        var now = new Date();
        var year = now.getFullYear(); //得到年份
        var month = now.getMonth(); //得到月份
        var date = now.getDate(); //得到日期
        //var hour =" 00:00:00"; //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
        month = month + 1;
        month = month.toString().padStart(2, "0");
        date = date.toString().padStart(2, "0");
        var defaultDate = `${year}-${month}-${date}`;
        console.log(defaultDate)
        return defaultDate;
        this.$set(this.info, "stockDate", defaultDate);
      },
  },
  mounted() {
    this.query();
  }
};
</script>

<style>
</style>
<style>
    .chosedialog .body_dilog{
        padding-top: 0px!important;
    }
    .chosedialog .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .chosedialog .el-dialog__body{
        padding: 0px 20px!important;
    }
    .chosedialog .h-pagination{
        padding-top:0px !important;
        padding-bottom:0px !important;
    }
	.ljjcaozuo .el-button [class*=el-icon-]+span{
		margin-left: 0;
	}
	.ljjcaozuo .h-el-icon{
		margin-right: 0;
	}
	.smTableRq .el-table tbody td .cell {
	    padding-top: 0.03rem;
	    padding-bottom: 0.03rem;
	}
	.smTableRq .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.smTableRq .el-input__inner{
		background: transparent;
	}
	.ljjtablepaddingsrq .h-tableInput{
		margin-top: 0.05rem;
	}
	.ljjtablepaddingsrq .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
		color: #616467;
		font-size: 0.16rem;
	}
	.ljjtablepaddingsrq .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>
